export default (state = () => { return null }, { type, payload }) => {
  switch (type) {
    case 'SET_THREE_D_MAP_REFERENCE':
      return payload
    case 'LOGOUT':
      return () => { return null }
    default:
      return state
  }
}